import PanelFooter from './PanelFooter'

export default PanelFooter
